import React, { useEffect, useRef } from "react";
import { matchRoutes, Route, Routes, useLocation, useNavigate, Navigate } from "react-router-dom";
import AudiosDetailPage from "../Pages/AudioPlayerPage";
import FooterPage from "./FooterPage";
import HeaderPage from "./HeaderPage";
// import BooksPage from "../Pages/BooksPage";
import BookDetailPage from "../Pages/BookDetailPage";
// import EpubPage from "../Pages/Epub";
import KalyansPage from "../Pages/KalyansPage";
import KalyanDetailPage from "../Pages/KalyanDetailPage";
import PravachansPage from "../Pages/PravachansPage";
import AudiosPage from "../Pages/AudiosPage";
import ArticlesPage from "../Pages/ArticlesPage";
import ArticlesDetailPage from "../Pages/ArticlesDetail";
import KalpataruPage from "../Pages/KalpataruPage";
import KalpataruDetailPage from "../Pages/KalpataruDetailPage";
import GeetgovindPage from "../Pages/GeetgovindPage";
import GeetGovindDetailPage from "../Pages/GeetGovindDetailPage";
import PrivacyPage from "../Pages/PrivacyPolicyPage";
import TearmsOfUsePage from "../Pages/TermsOfUsePage";
import FaqPage from "../Pages/FaqPage";
import AuthorsDataPage from "../Pages/AuthorsPage";
import SearchDataPage from "../Pages/SearchDataPage";
import { ProfileFav } from "../Pages/ProfileFav";
import { ProfileContact } from "../Pages/ProfileContact";
import VivekvaniPage from "../Pages/VivekVani";
import DivineQuotes from "../Pages/DivineQuotePage";
import DailySatsangPage from "../Pages/DailySatsang";
import PromotionPage from "../Pages/PromotionPage";
import PDFViewer from "../Pages/PDFViewer";
import FullImage from "../Pages/FullImage";
import NewLoginPage from "../Pages/NewLoginPage";
import VideoPlayerPage from "../Pages/VideoPlayerPage";
import MaintencePage from "../Pages/MaintencePage";
import InternetPage from "../Pages/NoInternetConnection"
import WebViewforbook from "../Pages/WebView";
import VivekvaniDetailPage from "../Pages/VivekvaniDetailPage";

const HomePage = React.lazy(
  () => import("../Pages/HomePage" /* webpackChunkName: "home" */)
);

const AboutPage = React.lazy(
  () => import("../Pages/AboutPage")
)

const Profile = React.lazy(
  () => import("../Pages/Profile" /* webpackChunkName: "home" */)
);

const EpubPage = React.lazy(
  () => import("../Pages/Epub" /* webpackChunkName: "epub" */)
);

const BooksPage = React.lazy(
  () => import("../Pages/BooksPage" /* webpackChunkName: "epub" */)
);
const WithHeaderFooter = ({ element }: { element: any }) => {
  return (
    <>
      <div
        style={{
          width: "100vw",
          minHeight: "100vh",
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
          overflowX: "hidden",
        }}
      >
        <HeaderPage />
        {element}
        <FooterPage />
      </div>
    </>
  );
};

// const NotFoundRedirect = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const lastValidPath = useRef("/");

//   useEffect(() => {
//     // 👇 build route definitions directly from your JSX (no duplication)
//     const routes = [
//       { path: "/fullimage" },
//       { path: "/" },
//       { path: "/home" },
//       { path: "/about" },
//       { path: "/books" },
//       { path: "/books/special" },
//       { path: "/books/author/:id" },
//       { path: "/books/language/:langid" },
//       { path: "/books/category/:catid" },
//       { path: "/books/:bookid" },
//       { path: "/books/special/:bookid" },
//       { path: "/books/author/:authorId/:bookid" },
//       { path: "/books/language/:langId/:bookid" },
//       { path: "/books/category/:catId/:bookid" },
//       { path: "/reader/:type/:id" },
//       { path: "/vivekvani" },
//       { path: "/vivekvani/special" },
//       { path: "/vivekvani/author/:id" },
//       { path: "/vivekvani/language/:langid" },
//       { path: "/vivekvani/:cat/:langid" },
//       { path: "/vivekvani/:vaniid" },
//       { path: "/vivekvani/special/:vaniid" },
//       { path: "/vivekvani/author/:id/:vaniid" },
//       { path: "/vivekvani/category/:catid" },
//       { path: "/vivekvani/language/:langid" },
//       { path: "/kalyan" },
//       { path: "/kalyan/category/:catid" },
//       { path: "/kalyan/special" },
//       { path: "/kalyan/author/:id" },
//       { path: "/kalyan/language/:langid" },
//       { path: "/kalyan/:kalyanid" },
//       { path: "/kalyan/special/:kalyanid" },
//       { path: "/kalyan/author/:id/:kalyanid" },
//       { path: "/kalyan/category/:catid/:kalyanid" },
//       { path: "/kalyan/language/:langid/:kalyanid" },
//       { path: "/kalyanakalpataru" },
//       { path: "/kalyanakalpataru/category/:catid" },
//       { path: "/kalyanakalpataru/special" },
//       { path: "/kalyanakalpataru/author/:id" },
//       { path: "/kalyanakalpataru/language/:langid" },
//       { path: "/kalyanakalpataru/:kalyanid" },
//       { path: "/kalyanakalpataru/special/:kalyanid" },
//       { path: "/kalyanakalpataru/author/:id/:kalyanid" },
//       { path: "/kalyanakalpataru/category/:catid/:kalyanid" },
//       { path: "/kalyanakalpataru/language/:langid/:kalyanid" },
//       { path: "/geetgovind" },
//       { path: "/geetgovind/category/:catid" },
//       { path: "/geetgovind/special" },
//       { path: "/geetgovind/author/:id" },
//       { path: "/geetgovind/language/:langid" },
//       { path: "/geetgovind/:id" },
//       { path: "/geetgovind/special/:id" },
//       { path: "/geetgovind/author/:id" },
//       { path: "/geetgovind/category/:catid/:id" },
//       { path: "/geetgovind/language/:langid/:id" },
//       { path: "/pravachans" },
//       { path: "/pravachans/special" },
//       { path: "/pravachans/author/:id" },
//       { path: "/pravachans/:id" },
//       { path: "/pravachans/:cat/:id" },
//       { path: "/audios" },
//       { path: "/audios/special" },
//       { path: "/audios/author/:id" },
//       { path: "/audios/:id" },
//       { path: "/audios/:cat/:id" },
//       { path: "/DailySatsang/:id" },
//       { path: "/DailySatsang" },
//       { path: "/videos" },
//       { path: "/videos/author/:id" },
//       { path: "/videos/category/:id" },
//       { path: "/videos/video/:id" },
//       { path: "/articles" },
//       { path: "/articles/special" },
//       { path: "/articles/author/:id" },
//       { path: "/articles/:id" },
//       { path: "/articles/special/:id" },
//       { path: "/articles/author/:id/:articleid" },
//       { path: "/divinequotes" },
//       { path: "/privacypolicy" },
//       { path: "/termsofuse" },
//       { path: "/faq" },
//       { path: "/promotion" },
//       { path: "/author/:id" },
//       { path: "/searchdata/:searchCategory/:search" },
//       { path: "/searchdata/:searchCategory/" },
//       { path: "/searchdata/:searchCategory/*" },
//       { path: "/profile/" },
//       { path: "/profile/My-Favourites" },
//       { path: "/profile/feedback" },
//       { path: "/pdf-viewer" },
//     ];

//     const matches = matchRoutes(routes, location);

//     if (matches) {
//       lastValidPath.current = location.pathname;
//     } else {
//       navigate(-1 as any);
//       // navigate(-1 as any, { replace: true });
//       // navigate(lastValidPath.current, { replace: true });
//     }
//   }, [location, navigate]);

//   return null;
// };


const AppRoutes = () => {
  return (
    <Routes>

      <Route element={<WebViewforbook />} path="/webView"></Route>
      {/* <Route element={<WithHeaderFooter element={<HomePage />} />} path="*" /> */}
      {/* <Route path="*" element={<NotFoundRedirect />} /> */}
      {/* full image path */}
      <Route element={<FullImage />} path="/fullimage"></Route>

      <Route element={<WithHeaderFooter element={<HomePage />} />} path="/"></Route>
      <Route element={<WithHeaderFooter element={<HomePage />} />} path="/home"></Route>

      <Route
        element={<WithHeaderFooter element={<AboutPage />} />}
        path="/about"
      ></Route>

      {/* book */}

      <Route
        element={<WithHeaderFooter element={<BooksPage />} />}
        path="/books"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<BooksPage />} />}
        path="/books/special"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<BooksPage />} />}
        path="/books/author/:id"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<BooksPage />} />}
        path="/books/language/:langid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<BooksPage />} />}
        path="/books/category/:catid"
      ></Route>

      {/* Book Detail */}

      <Route
        element={<WithHeaderFooter element={<BookDetailPage />} />}
        path="/books/:bookid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<BookDetailPage />} />}
        path="/books/:slug"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<BookDetailPage />} />}
        path="/books/special/:bookid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<BookDetailPage />} />}
        path="/books/author/:authorId/:slug"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<BookDetailPage />} />}
        path="/books/language/:langId/:slug"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<BookDetailPage />} />}
        path="/books/category/:catId/:slug"
      ></Route>

      {/* epub */}

      <Route element={
        <React.Suspense fallback={<div>Loading...</div>}>
          <EpubPage />
        </React.Suspense>
      } path="reader/:type/:id"></Route>

      {/* vivekvani */}

      <Route
        element={<WithHeaderFooter element={<VivekvaniPage />} />}
        path="/vivekvani"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VivekvaniPage />} />}
        path="/vivekvani/special"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VivekvaniPage />} />}
        path="/vivekvani/author/:id"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VivekvaniPage />} />}
        path="/vivekvani/language/:langid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VivekvaniPage />} />}
        path="/vivekvani/:cat/:langid"
      ></Route>

      {/* Vivek Vani Detail */}

      <Route
        element={<WithHeaderFooter element={<VivekvaniDetailPage />} />}
        path="/vivekvani/:slug"
      ></Route>

      {/* <Route
        element={<WithHeaderFooter element={<VivekvaniDetailPage />} />}
        path="/vivekvani/:vaniid"
      ></Route> */}

      <Route
        element={<WithHeaderFooter element={<VivekvaniDetailPage />} />}
        path="/vivekvani/special/:vaniid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VivekvaniDetailPage />} />}
        path="/vivekvani/author/:id/:vaniid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VivekvaniDetailPage />} />}
        path="/vivekvani/category/:catid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VivekvaniDetailPage />} />}
        path="/vivekvani/language/:langid"
      ></Route>

      {/* Kalyan */}

      <Route
        element={<WithHeaderFooter element={<KalyansPage />} />}
        path="/kalyan"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalyansPage />} />}
        path="/kalyan/category/:catid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalyansPage />} />}
        path="/kalyan/special"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalyansPage />} />}
        path="/kalyan/author/:id"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalyansPage />} />}
        path="/kalyan/language/:langid"
      ></Route>

      {/* Kalyan Detail  */}

      <Route
        element={<WithHeaderFooter element={<KalyanDetailPage />} />}
        path="/kalyan/:slug"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalyanDetailPage />} />}
        path="/kalyan/special/:kalyanid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalyanDetailPage />} />}
        path="/kalyan/author/:id/:kalyanid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalyanDetailPage />} />}
        path="/kalyan/category/:catid/:kalyanid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalyanDetailPage />} />}
        path="/kalyan/language/:langid/:kalyanid"
      ></Route>

      {/* Kalpataru Page */}

      <Route
        element={<WithHeaderFooter element={<KalpataruPage />} />}
        path="/kalyanakalpataru"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalpataruPage />} />}
        path="/kalyanakalpataru/category/:catid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalpataruPage />} />}
        path="/kalyanakalpataru/special"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalpataruPage />} />}
        path="/kalyanakalpataru/author/:id"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalpataruPage />} />}
        path="/kalyanakalpataru/language/:langid"
      ></Route>

      {/* Kalpataru Detail  */}

      <Route
        element={<WithHeaderFooter element={<KalpataruDetailPage />} />}
        path="/kalyanakalpataru/:slug"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalpataruDetailPage />} />}
        path="/kalyanakalpataru/special/:kalyanid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalpataruDetailPage />} />}
        path="/kalyanakalpataru/author/:id/:kalyanid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalpataruDetailPage />} />}
        path="/kalyanakalpataru/category/:catid/:kalyanid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<KalpataruDetailPage />} />}
        path="/kalyanakalpataru/language/:langid/:kalyanid"
      ></Route>

      {/* Geet Govind Page */}

      <Route
        element={<WithHeaderFooter element={<GeetgovindPage />} />}
        path="/geetgovind"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<GeetgovindPage />} />}
        path="/geetgovind/category/:catid"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<GeetgovindPage />} />}
        path="/geetgovind/special"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<GeetgovindPage />} />}
        path="/geetgovind/author/:id"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<GeetgovindPage />} />}
        path="/geetgovind/language/:langid"
      ></Route>

      {/* GeetGovindDetailPage */}

      {/* <Route
        element={<WithHeaderFooter element={<GeetGovindDetailPage />} />}
        path="/geetgovind/:id"
      ></Route> */}

      <Route
        element={<WithHeaderFooter element={<GeetGovindDetailPage />} />}
        path="/geetgovind/:slug"
      ></Route>

      <Route
        element={<WithHeaderFooter element={<GeetGovindDetailPage />} />}
        path="/geetgovind/special/:id"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<GeetGovindDetailPage />} />}
        path="/geetgovind/category/:catid/:id"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<GeetGovindDetailPage />} />}
        path="/geetgovind/language/:langid/:id"
      ></Route>

      {/* pravachan page */}

      <Route
        element={<WithHeaderFooter element={<PravachansPage />} />}
        path="/pravachans"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<PravachansPage />} />}
        path="/pravachans/special"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<PravachansPage />} />}
        path="/pravachans/author/:id"
      ></Route>

      {/* pravachan detail page */}

      <Route element={<AudiosDetailPage />} path="/pravachans/:id"></Route>
      <Route element={<AudiosDetailPage />} path="/pravachans/:cat/:id"></Route>

      {/* audio page */}

      <Route
        element={<WithHeaderFooter element={<AudiosPage />} />}
        path="/audios"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<AudiosPage />} />}
        path="/audios/special"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<AudiosPage />} />}
        path="/audios/author/:id"
      ></Route>

      {/* audio player page */}
      <Route element={<AudiosDetailPage />} path="/audios/:slug"></Route>
      <Route element={<AudiosDetailPage />} path="/audios/:id"></Route>
      <Route element={<AudiosDetailPage />} path="/audios/:cat/:id"></Route>
      <Route element={<AudiosDetailPage />} path="/DailySatsang/:slug"></Route>
      <Route element={<AudiosDetailPage />} path="/DailySatsang/:id"></Route>
      <Route element={<AudiosDetailPage />} path="/DailySatsang/*"></Route>

      {/* daily satsang page */}

      <Route
        element={<WithHeaderFooter element={<DailySatsangPage />} />}
        path="/DailySatsang"
      ></Route>

      {/* video player page */}
      <Route
        element={<WithHeaderFooter element={<VideoPlayerPage />} />}
        path="/videos"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VideoPlayerPage />} />}
        path="/videos/author/:id"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VideoPlayerPage />} />}
        path="/videos/category/:id"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<VideoPlayerPage />} />}
        path="/videos/video/:id"
      ></Route>

      {/* artical page */}

      <Route
        element={<WithHeaderFooter element={<ArticlesPage />} />}
        path="/articles"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<ArticlesPage />} />}
        path="/articles/special"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<ArticlesPage />} />}
        path="/articles/author/:id"
      ></Route>

      {/* article detail page */}

      {/* <Route
        element={<WithHeaderFooter element={<ArticlesDetailPage />} />}
        path="/articles/:id"
      ></Route> */}
      <Route
        element={<WithHeaderFooter element={<ArticlesDetailPage />} />}
        path="/articles/:slug"
      ></Route>

      <Route
        element={<WithHeaderFooter element={<ArticlesDetailPage />} />}
        path="/articles/special/:id"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<ArticlesDetailPage />} />}
        path="/articles/author/:id/:articleid"
      ></Route>

      {/* Divine Quotes Page */}

      {/* <Route
        element={<WithHeaderFooter element={<DivineQuotes />} />}
        path="/divinequotes"
      ></Route> */}

      <Route
        element={<WithHeaderFooter element={<DivineQuotes />} />}
        path="/divinequotes"
      ></Route>
      <Route
        element={<WithHeaderFooter element={<DivineQuotes />} />}
        path="/divinequotes/:id"
      ></Route>

      <Route
        element={<WithHeaderFooter element={<PrivacyPage />} />}
        path="/privacypolicy"
      ></Route>

      <Route
        element={<WithHeaderFooter element={<TearmsOfUsePage />} />}
        path="/termsofuse"
      ></Route>

      <Route
        element={<WithHeaderFooter element={<FaqPage />} />}
        path="/faq"
      ></Route>

      <Route
        element={<WithHeaderFooter element={<PromotionPage />} />}
        path="/promotion"
      ></Route>

      <Route
        element={<WithHeaderFooter element={<AuthorsDataPage />} />}
        path="/author/:id"
      ></Route>

      <Route
        element={<WithHeaderFooter element={<SearchDataPage />} />}
        path="/searchdata/:searchCategory/:search"
      ></Route>

      <Route
        element={<WithHeaderFooter element={<SearchDataPage />} />}
        path="/searchdata/:searchCategory/"
      ></Route>

      <Route
        element={<WithHeaderFooter element={<SearchDataPage />} />}
        path="/searchdata/:searchCategory/*"
      ></Route>

      {/* profile Page's */}

      <Route
        element={<WithHeaderFooter element={<Profile />} />}
        path="/profile/"
      ></Route>

      {/* New login route: accepts a trailing URL section as a param, e.g. /Login/audios/5ffd8367c6390b697e2a5d52 */}
      <Route element={<NewLoginPage />} path="/Login/*"></Route>


      <Route
        element={<WithHeaderFooter element={<ProfileFav />} />}
        path="/profile/My-Favourites"
      ></Route>

      <Route
        element={<WithHeaderFooter element={<ProfileContact />} />}
        path="/profile/feedback"
      ></Route>

      {/* Pdf Viewer */}

      <Route element={<PDFViewer />} path="/pdf-viewer"></Route>
      {/* fallback: redirect unknown URLs back to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
export default AppRoutes;
